document.documentElement.classList.remove("no-js");

const header = document.querySelector("[data-header]");
const menuButton = document.querySelector("[data-menu-button]");
const nav = document.querySelector("[data-nav]");
const menuBackdrop = document.querySelector("[data-menu-backdrop]");
const toast = document.querySelector("[data-toast]");

const closeMenu = () => {
  if (!menuButton || !nav) return;
  nav.classList.remove("is-open");
  menuButton.setAttribute("aria-expanded", "false");
  document.body.classList.remove("menu-open");
};

menuButton?.addEventListener("click", () => {
  const open = nav.classList.toggle("is-open");
  menuButton.setAttribute("aria-expanded", String(open));
  document.body.classList.toggle("menu-open", open);
});

nav?.querySelectorAll("a").forEach((link) => link.addEventListener("click", closeMenu));
menuBackdrop?.addEventListener("click", closeMenu);
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeMenu();
});
window.addEventListener("resize", () => {
  if (window.innerWidth > 1100) closeMenu();
});

const updateHeader = () => header?.classList.toggle("is-scrolled", window.scrollY > 8);
updateHeader();
window.addEventListener("scroll", updateHeader, { passive: true });

document.querySelectorAll("[data-language-select]").forEach((select) => {
  select.addEventListener("change", () => select.form?.submit());
});

document.querySelectorAll("[data-sort-select]").forEach((select) => {
  select.addEventListener("change", () => select.form?.submit());
});

document.querySelectorAll("[data-variant-select]").forEach((select) => {
  select.addEventListener("change", () => {
    const price = select.selectedOptions[0]?.dataset.price;
    const root = select.closest("[data-product-root]");
    if (price && root) root.querySelector("[data-product-price]").textContent = price;
  });
});

const showToast = (message) => {
  if (!toast || !message) return;
  toast.textContent = message;
  toast.classList.add("is-visible");
  window.clearTimeout(showToast.timer);
  showToast.timer = window.setTimeout(() => toast.classList.remove("is-visible"), 3200);
};

const updateCartCount = async () => {
  const root = window.Shopify?.routes?.root || "/";
  const response = await fetch(`${root}cart.js`, { headers: { Accept: "application/json" } });
  if (!response.ok) return;
  const cart = await response.json();
  document.querySelectorAll("[data-cart-count]").forEach((node) => {
    node.textContent = cart.item_count;
  });
};

document.querySelectorAll("[data-product-form]").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    if (!window.fetch) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button?.setAttribute("disabled", "disabled");

    try {
      const response = await fetch(`${form.action}.js`, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error("Cart request failed");
      await response.json();
      await updateCartCount();
      showToast(document.body.dataset.cartAdded);
    } catch (error) {
      showToast(document.body.dataset.cartError);
    } finally {
      button?.removeAttribute("disabled");
    }
  });
});

const revealNodes = document.querySelectorAll(".reveal");
if ("IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.08 }
  );
  revealNodes.forEach((node) => observer.observe(node));
} else {
  revealNodes.forEach((node) => node.classList.add("is-visible"));
}
